import axios from 'axios';
const baseURL = window._env_.API_BASE_URL;

export default axios.create({
  baseURL,
  headers: { 'Content-type': 'application/json' },
});